import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 21479 21588"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528313122576">
        <path
          d="M18514 19174H2962c-112 0-202-90-202-202V204c0-112 90-202 202-202l15552 1c112 0 202 89 202 201v18768c0 109-90 202-202 202zm-15350-404h15148V406H3164v18364z"
          className="fil0"
        />
        <path
          d="M19792 19174H1689c-112 0-202-90-202-202V204c0-112 90-202 202-202l18103 1c112 0 202 89 202 201v18768c0 109-93 202-202 202zm-17903-404h17701V406H1889v18364z"
          className="fil0"
        />
        <path
          d="M20493 21588H986c-543 0-986-443-986-986v-849c0-543 443-986 986-986h19507c542 0 986 443 986 986v849c0 543-444 986-986 986zM986 19174c-322 0-582 260-582 581v850c0 321 260 582 582 582h19507c321 0 582-261 582-582v-850c0-321-261-581-582-581H986zM4907 15732c-1183 0-2147-963-2147-2146V202c0-112 90-202 202-202h3889c112 0 202 90 202 202v13384c0 1185-964 2146-2146 2146zM3164 406v13182c0 961 781 1743 1743 1743 961 0 1742-782 1742-1743V406H3164z"
          className="fil0"
        />
        <path
          d="M8796 13939c-1183 0-2147-964-2147-2147V204c0-112 90-201 202-201h3889c113 0 202 89 202 201v11588c-2 1183-963 2147-2146 2147zM7053 406v11386c0 961 782 1743 1743 1743s1743-782 1743-1743V406H7053z"
          className="fil0"
        />
        <path
          d="M12683 12142c-1183 0-2147-963-2147-2146V204c0-112 90-201 202-201h3889c112 0 202 89 202 201v9792c0 1183-961 2146-2146 2146zM10940 406v9590c0 961 781 1742 1743 1742 961 0 1742-781 1742-1742V406h-3485z"
          className="fil0"
        />
        <path
          d="M16572 10346c-1183 0-2147-961-2147-2146V204c0-112 90-202 202-202l3887 1c112 0 202 89 202 201v7996c0 1182-961 2146-2144 2146zM14829 406v7794c0 961 781 1742 1743 1742 961 0 1742-781 1742-1742V406h-3485zM7683 18003c-51 0-102-19-143-58-78-78-78-207 0-285l3468-3468c80-81 207-81 285 0 80 77 80 207 0 284l-3468 3469c-39 39-90 58-142 58zM12943 15988c-51 0-102-20-143-58-79-79-79-207 0-285l2042-2042c77-78 206-78 284 0 81 78 81 206 0 285l-2042 2042c-39 38-90 58-141 58z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
